import baseEditForm from "formiojs/components/_classes/component/Component.form";
const locationSelect = require("./location.json");
const countryList = require("country-list");
const provincesList = require("provinces");
const countryListData = countryList.getData();
let countries = [];
countryListData.forEach(x => countries.push({ value: x.code, label: x.name }));

const conditionalStates = x => {
  let provinces = [];
  var instance = x.instance;
  var data = instance.data;

  const filteredProvinces = provincesList.filter(province => province.country == data["countryRestrictionWhenSearching"]);

  if (filteredProvinces.length > 0) {
    filteredProvinces.forEach(fp => provinces.push({ value: fp.short, label: fp.name }));
  }

  return provinces;
};

export default (...extend) => {
  return baseEditForm(
    [
      {
        key: "display",
        components: [
          {
            weight: 12,
            key: "mapItButtonText",
            label: "Map It Button Text",
            input: true,
            type: "textfield",
            defaultValue: "Map It"
          },
          {
            weight: 12,
            key: "title",
            label: "Map It Modal Title",
            input: true,
            type: "textfield",
            defaultValue: "Nebraska"
          }
        ]
      },
      {
        key: "data",
        components: []
      },
      {
        key: "validation",
        components: []
      },
      {
        key: "api",
        components: [
          {
            key: "arcgisUrl",
            type: "textfield",
            input: true,
            label: "ArcGIS Url",
            defaultValue: "https://js.arcgis.com/4.10/"
          },
          {
            key: "geocodeServer",
            type: "textfield",
            input: true,
            label: "Geocode Server",
            defaultValue: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer" //"https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer"
          },
          {
            key: "esriLoadTimeoutSeconds",
            type: "textfield",
            input: true,
            label: "Esri Load Timeout (seconds)",
            defaultValue: "60"
          },
          {
            key: "externalApiUrl",
            type: "textfield",
            input: true,
            label: "External Api Url",
            defaultValue: "http://localhost:8000"
          }
        ]
      },
      {
        key: "conditional",
        components: []
      },
      {
        key: "logic",
        components: []
      },
      {
        key: "options",
        label: "Map Options",
        weight: 60,
        components: [
          {
            key: "countryRestrictionWhenSearching",
            label: "Country Restriction",
            type: "select",
            input: true,
            dataSrc: "values",
            data: {
              values: countries
            }
          },
          {
            key: "stateRestrictionWhenSearching",
            label: "State Restriction",
            type: "select",
            input: "true",
            dataSrc: "custom",
            data: {
              custom: function(x) {
                return conditionalStates(x);
              }
            }
          },
          {
            type: "textfield",
            input: true,
            key: "minimumZoom",
            label: "Minimum Zoom"
          },
          {
            type: "textfield",
            input: true,
            key: "distanceAdjustmentThreshold",
            label: "Distance Adjustment Threshold"
          },
          {
            type: "container",
            key: "defaultCenterPoint",
            label: "Default Map Center",
            components: [
              {
                type: "textfield",
                label: "Latitude",
                key: "defaultLatitude",
                input: true
              },
              {
                type: "textfield",
                label: "Longitude",
                key: "defaultLongitude",
                input: true
              }
            ]
          },
          {
            type: "checkbox",
            input: true,
            key: "snapToRoadway",
            label: "Snap to Roadway?"
          },
          {
            type: "checkbox",
            input: true,
            key: "allowUnableToMap",
            label: "Allow Unable to Map?",
            defaultValue: true
          },
          {
            type: "editgrid",
            key: "mapOptions",
            label: "Map Options",
            input: true,
            addAnother: "Add Location Mapping",
            storeas: "array",
            templates: {
              header:
                '<div class="row"> \n  <div class="col-sm-12">\n    <strong>{{ value.length }} Location Mapping(s)</strong>\n  </div>\n</div>',
              row:
                '<div class="row"> \n  <div class="col-sm-6">\n   <b>\n{{ row.locationProperty }}</b>\n  </div>\n  <div class="col-sm-6"> \n    <div class="btn-group pull-right"> \n      <div class="btn btn-info editRow">Edit</div> \n      <div class="btn btn-danger removeRow">Delete</div> \n    </div> \n  </div> \n</div>',
              footer: ""
            },
            components: [
              {
                key: "locationProperty",
                type: "select",
                input: true,
                label: "Location Property",
                dataSrc: "values",
                data: {
                  values: locationSelect
                }
              },
              {
                key: "formComponent",
                type: "textfield",
                label: "Form Component API Property Name",
                input: true
              }
            ]
          },
          {
            key: "featureLayers",
            type: "editgrid",
            input: true,
            storeas: "array",
            addAnother: "Add Feature Layer",
            label: "Feature Layers",
            templates: {
              header:
                '<div class="row"> \n  <div class="col-sm-12">\n    <strong>{{ value.length }} Feature Layer(s)</strong>\n  </div>\n</div>',
              row:
                '<div class="row"> \n  <div class="col-sm-6">\n   <b>\n{{ row.featureLayerUrl }}</b>\n  </div>\n  <div class="col-sm-6"> \n    <div class="btn-group pull-right"> \n      <div class="btn btn-info editRow">Edit</div> \n      <div class="btn btn-danger removeRow">Delete</div> \n    </div> \n  </div> \n</div>',
              footer: ""
            },
            components: [
              {
                key: "featureLayerUrl",
                label: "Feature Layer URL",
                type: "textfield",
                input: true
              },
              {
                key: "minScale",
                label: "Minimum Scale",
                type: "textfield",
                input: true
              }
            ]
          }
        ]
      }
    ],
    ...extend
  );
};
